export default ({ app, store }, inject) => {
  const ShowMessage = (content, color) => {
    store.commit("snackbar/showMessage", { content, color })
  }
  inject("notify", new ShowMessage())
}
